module.exports = __webpack_public_path__ + "static/media/medicare-guide-2024-WNY.24f8e3c1.png";